import axios from '../../v2/app/services/axiosService';

export default {
  async sendEmail(recipients, subject, body, css = null, formData = {}) {
    const form = {
      body,
      css,
      formData,
      recipients,
      subject,
      ...formData,
    }
    const response = await axios.post(`/api/emails/send`, form);
    return response.data;
  }
}
